// Copied from reactcomponents/lib/utils.ts
// decode a base64 string to a utf-8 string
export function atob_utf8(value: string) {
  const value_latin1 = atob(value);
  return new TextDecoder("utf-8").decode(
    Uint8Array.from({ length: value_latin1.length }, (_, index) =>
      value_latin1.charCodeAt(index)
    )
  );
}
